import apiConnector from "requests/axios.config";

export default apiConnector("api/v1");
